import { openWithStackblitzAuth } from '~/lib/.client/openWithStackblitzAuth';
import type { BillingPeriod } from '~/lib/.server/rateLimit';
import type { OrganizationData } from '~/types/organization';
import type { IdentityUserData, UserData } from '~/types/user';

export function getBillingPeriod(userData: UserData | IdentityUserData): BillingPeriod | undefined {
  if ('activeOrganizationId' in userData && userData.activeOrganizationId) {
    const org = userData.organizations?.find(({ id }) => id === userData.activeOrganizationId);

    if (!org || !org.billing || !org.billing.subscription) {
      return undefined;
    }

    return {
      from: org.billing.subscription.currentMonthStartTimestamp,
      to: org.billing.subscription.nextMonthStartTimestamp,
    };
  }

  if (userData.membership?.subscription) {
    const { currentMonthStartTimestamp, nextMonthStartTimestamp } = userData?.membership?.subscription;

    return {
      from: currentMonthStartTimestamp,
      to: nextMonthStartTimestamp,
    };
  }

  return undefined;
}

const moneyFormatter = new Intl.NumberFormat(typeof navigator !== 'undefined' ? navigator.language : 'en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
});

export function formatPriceInCents(priceInCents: number) {
  return moneyFormatter.format(priceInCents / 100);
}

export function redirectToOrgBillingPage(org: OrganizationData) {
  openWithStackblitzAuth(`/orgs/${org.provider}/${org.slug}/subscription/billing`);
}

export function redirectToTeamsMembersPage(org: OrganizationData) {
  openWithStackblitzAuth(`/orgs/${org.provider}/${org.slug}/members`);
}
